//@TODO: Em breve encontrar uma forma de fazer com que **module** seja sempre obtido da requisicao, e nao informado fixo no tratamento de excessao
export class IdhaApiException extends Error {
    constructor(public module:string,public errorCode:string|number,public statusCode?:string|number) {
        super("ERROR_"+module.toUpperCase()+"_"+errorCode);
    }
}